"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetState = exports.setSelectedPickup = void 0;
const state_1 = require("./state");
const setSelectedPickup = (state, pickup) => {
    state.selectedPickup = pickup === null || pickup === void 0 ? void 0 : pickup.time;
    state.activeVendorId = pickup === null || pickup === void 0 ? void 0 : pickup.id;
};
exports.setSelectedPickup = setSelectedPickup;
const resetState = (state) => {
    Object.assign(state, (0, state_1.getDefaultState)());
};
exports.resetState = resetState;
